// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__1XkIO","tab":"ProcedureTabs_tab__RYNud"};